import { render, staticRenderFns } from "./ProjectAlarmAdd.vue?vue&type=template&id=984b5e96&scoped=true&"
import script from "./ProjectAlarmAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectAlarmAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAlarmAdd.vue?vue&type=style&index=0&id=984b5e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984b5e96",
  null
  
)

export default component.exports